// extracted by mini-css-extract-plugin
module.exports = {"sharePopover":"e3","shareText":"e4","show":"e5"};